import React from 'react'
import { noSearchResultMessage } from '@chegg-wt/core/utils/searchSourcesMap'
import { SEARCH_RESULT } from '@chegg-wt/core/utils/searchSources'
import { SourceType } from '@chegg-wt/core/types/core'
import SourceToolTip from '../Tooltip/SourceTooltip'
import { SEARCH_RESULT_EMPTY } from './utils/testids'
import * as Styled from './styled'

interface SearchResultsEmptyProps {
  heading?: string
  copy?: string
  image: React.ReactNode
  sourceType?: SourceType
}

const SearchResultsEmpty: React.FC<SearchResultsEmptyProps> = ({
  heading,
  copy,
  image,
  sourceType,
}) => {
  if (sourceType && noSearchResultMessage[sourceType?.id]) {
    return (
      <Styled.EmptyContainer data-test={SEARCH_RESULT_EMPTY}>
        <Styled.LoadingDescription>
          <Styled.Heading role="alert">
            {noSearchResultMessage[sourceType.id].title}
          </Styled.Heading>
          <Styled.NoResultBody>
            {noSearchResultMessage[sourceType?.id].body}
            <SourceToolTip sourceType={sourceType} location={SEARCH_RESULT} />
          </Styled.NoResultBody>
        </Styled.LoadingDescription>
      </Styled.EmptyContainer>
    )
  }

  return (
    <Styled.EmptyContainer data-test={SEARCH_RESULT_EMPTY}>
      {image}
      <Styled.LoadingDescription>
        {heading && <Styled.Heading role="alert">{heading}</Styled.Heading>}
        {copy && <Styled.Body>{copy}</Styled.Body>}
      </Styled.LoadingDescription>
    </Styled.EmptyContainer>
  )
}

export default SearchResultsEmpty
